export const pathNames = {
  usersPage: '/users',
  userPage: '/user',
  registrationPage: '/registration-data',
  invoices: '/invoices',
  bituahLeumiPayment: '/automated-payments',
  invoiceOrders: '/invoice-orders',
  receipts: '/receipts',
  completeDetails: '/complete-details',
  partners: '/partners',
  invitedUsersPage: '/invited-users',
  customersPage: '/customers',
  agentsIncomesPage: '/agents-incomes',
  unpaidAgentsPage: '/unpaid-agents',
  transfersByAgentPage: '/transfersByAgent',
  usersActionsPage: '/logs-users-actions',
  paypalRequestsPage: '/paypal-requests',
  transfersPage: '/all-transfers',
  bankStatementsPage: '/bank-statements',
};